import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IconModule, KeyboardFocusModule } from '@spartacus/storefront';
import { I18nModule } from '@spartacus/core';
import { HisenseFacetListComponent } from './facet-list.component';
import { HisenseFacetModule } from '../facet/facet.module';

@NgModule({
  declarations: [HisenseFacetListComponent],
  imports: [
    CommonModule,
    I18nModule,
    IconModule,
    HisenseFacetModule,
    KeyboardFocusModule,
  ],
  exports: [HisenseFacetListComponent],
})
export class HisenseFacetListModule {}
